import React from 'react';
import './css/index.css';
import './css/Site.css';
import './css/NavBar.css';

import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Site from "framework/ui/content/Site";
import MyPage from './MyPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Site pageElement={MyPage} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
